
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.8 27.4h-20c-.6 0-1-.4-1-1V13.2c0-.6.4-1 1-1h20c.6 0 1 .4 1 1v13.2c0 .6-.4 1-1 1zm-1-13.2h-18v11.2h18V14.2zM36.2 49.1h11.1c.6 0 1-.4 1-1V29.3c0-.6-.4-1-1-1H36.2c-.6 0-1 .4-1 1v18.8c0 .6.5 1 1 1zm1-18.8h9.1v16.8h-9.1V30.3zM33.8 49.1h-20c-.6 0-1-.4-1-1V29.3c0-.6.4-1 1-1h10.4c.6 0 1 .4 1 1v9.1h8.6c.6 0 1 .4 1 1v8.7c0 .6-.4 1-1 1zM23.2 30.3h-8.4v16.8h18v-6.7h-8.6c-.6 0-1-.4-1-1v-9.1z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.8 28.3h-7c-.6 0-1 .4-1 1v7.3c0 .6.4 1 1 1h7c.6 0 1-.4 1-1v-7.3c0-.5-.5-1-1-1zm-1 7.4h-5v-5.3h5v5.3zM47.3 27.4H36.2c-.5 0-1-.4-1-1V13.2c0-.6.4-1 1-1h11.1c.6 0 1 .4 1 1v13.2c0 .6-.4 1-1 1zm-1-13.2h-9.1v11.2h9.1V14.2z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11 9h38.9c.6 0 1 .4 1 1v40.9c0 .6-.4 1-1 1H11c-.6 0-1-.4-1-1V10c0-.6.4-1 1-1zm1 40.9h36.9V11H12v38.9z"}})])
          )
        }
      }
    